/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_UnskipInputs */

const cs_pm_unskip = /** @type {(inputs: Pm_UnskipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vrátit`)
};

const en_pm_unskip = /** @type {(inputs: Pm_UnskipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo skip`)
};

/**
* | output |
* | --- |
* | "Undo skip" |
*
* @param {Pm_UnskipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_unskip = /** @type {((inputs?: Pm_UnskipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_UnskipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_unskip(inputs)
	return cs_pm_unskip(inputs)
});